import { Component, EventEmitter, Input, Output } from '@angular/core';
@Component({
    selector: 'numericKeyboard',
    templateUrl: './numeric.keyboard.component.html',
})
export class NumericKeyboardComponent {
    inputValues = [];
    @Input() set inputSize(itemC) {
        for (let i = 0; i < itemC; i++) {
            this.inputValues.push('');
        }
    }

    @Input() password = false;

    @Output() onEntered = new EventEmitter();

    currentInput = 0;

    actions = {
        backspace: () => (this.inputValues[this.currentInput] = this.inputValues[this.currentInput].slice(0, -1)),
        enter: () => this.onEntered.emit(this.inputValues),
        input_back: () => (this.currentInput != 0 ? --this.currentInput : null),
        input_next: () => (this.currentInput != this.inputValues.length - 1 ? ++this.currentInput : null),
        inputNumber: e => (this.inputValues[this.currentInput] ? this.inputValues[this.currentInput] : '') + '' + e,
    };

    onNumPress(e) {
        console.log(typeof e);

        if (typeof e === 'string') {
            this.actions[e]();
        } else if (typeof e === 'number') {
            this.inputValues[this.currentInput] = this.actions.inputNumber(e);
        }
    }

    onFocusInput(e) {
        this.currentInput = e;
    }
}
